import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { useLazyGetNewsByIdQuery, useLazyGetNewsQuery, useUpdateStatusMutation } from 'app/services/edpApiV1/news';
import { useAppSelector } from 'app/store';
import { viewerModel } from 'entities/viewer';
import NewsTable from 'features/tables/newsTable';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { NewsTabs, SearchKeysNews } from 'shared/enums/news';
import { addNotifications, dataForNewsTable } from 'shared/helpers/utils';
import { INewsGetResponse, IUpdateNewsRequest, TNewsColumns, TSearchData } from 'shared/types/news.types';

const NewsArchive = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentSize, setCurrentSize] = useState<number>(10);
  const { role } = useAppSelector(viewerModel.me.selectors.selectViewerProfile);
  const [updateNewsStatusQuery, { isLoading: isUnarchiveLoading }] = useUpdateStatusMutation();
  const navigate = useNavigate();
  const [getnewsById, { isLoading: getByIdLoading }] = useLazyGetNewsByIdQuery();
  const { search } = useAppSelector(state => state.entities.search);
  const [result, setResult] = useState<INewsGetResponse[]>();
  const [total, setTotal] = useState<number>();
  const [currentUnarchiveNews, setCurrentUnarchiveNews] = useState<number[]>([]);
  const [searchData, setSearchData] = useState<TSearchData>({ key: SearchKeysNews.SEARCH_NAME, value: '' });

  const [getNewsLazy, resultAll] = useLazyGetNewsQuery();

  const onSearch = (data: string, key: SearchKeysNews) => {
    setSearchData({ key, value: data });
    getNewsLazy({ size: currentSize, page: currentPage, type: NewsTabs.ARCHIVE, [key]: data ? data : undefined });
  };

  useEffect(() => {
    setResult(resultAll.data?.data);
    setTotal(resultAll.data?.pagination.total);
  }, [resultAll]);

  useEffect(() => {
    getNewsLazy({
      size: currentSize,
      page: currentPage,
      type: NewsTabs.ARCHIVE,
      [searchData.key]: searchData.value ? searchData.value : undefined,
    });
  }, [currentPage, currentSize, getNewsLazy, search]);

  const unarchiveNews = async (id: number) => {
    setCurrentUnarchiveNews([...currentUnarchiveNews, id]);
    const clickedNews = await getnewsById({ id }).unwrap();
    const newsData: IUpdateNewsRequest = {
      id: clickedNews.id,
      created: clickedNews.created,
      title: clickedNews.title,
      content: clickedNews.content,
      userIds: clickedNews.users.map(user => user.id),
      retry: clickedNews.retry,
      datesToCreate: clickedNews.datesToCreate,
      time: clickedNews.time,
      days: clickedNews.days,
      divisionIds: clickedNews.divisions.map(elem => elem.id),
      organizationIds: clickedNews.organizations.map(elem => elem.id),
    };
    await addNotifications(
      updateNewsStatusQuery({ id: Number(id), status: NewsTabs.UNPUBLICATED }),
      'Новость восстановлена',
      'Ошибка при восстановлении новости',
    );
    setCurrentUnarchiveNews(currentUnarchiveNews.filter(elem => elem === id));
  };

  const onclickToRow = (id: number) => {
    navigate(`/news/info/${id}?fromArchive=true`);
  };

  const columns: TNewsColumns = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Заголовок',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Действие',
      key: 'action',
      render: (text, record) => {
        return (
          <>
            {currentUnarchiveNews.includes(record.id) && (isUnarchiveLoading || getByIdLoading) ? (
              <Spin indicator={<LoadingOutlined spin />} />
            ) : (
              <a
                onClick={(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                  e.stopPropagation();
                  return unarchiveNews(record.id);
                }}
              >
                Восстановить
              </a>
            )}
          </>
        );
      },
    },
    {
      title: 'Автор',
      dataIndex: 'fio',
      key: 'fio',
    },
  ];
  return (
    <Spin spinning={resultAll.isLoading || resultAll.isFetching}>
      {result ? (
        <NewsTable
          dataSource={dataForNewsTable(result) || []}
          columns={columns}
          currentPage={currentPage}
          currentSize={currentSize}
          setCurrentPage={setCurrentPage}
          setCurrentSize={setCurrentSize}
          total={total}
          onclickToRow={onclickToRow}
          onSearch={onSearch}
        />
      ) : null}
    </Spin>
  );
};

export default NewsArchive;
